import React from "react";
import {
    Navigate,
} from "react-router-dom";

const CantonListComponent = React.lazy(() => import("../../../../../components/canton/components/list/page"));
const CantonAddComponent = React.lazy(() => import("../../../../../components/canton/components/add/page"));

export const cantonRoute = [
    {
        path: 'list',
        element: <CantonListComponent />
    },
    {
        path: 'add',
        element: <CantonAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/models/cantons/add" />
    },
    {
        path: 'edit/:id',
        element: <CantonAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/models/cantons/list" />
    },
];